import { useEffect, useState } from 'react';
import SocialApi from '../api/social';

let cached = null;

// Configured sites for the site filter, fetched once per page load
export default function useSites() {
  const [sites, setSites] = useState([]);
  useEffect(() => {
    let current = true;
    cached ??= SocialApi.sites().then((data) => data.results).catch(() => {
      cached = null;
      return [];
    });
    cached.then((results) => current && setSites(results));
    return () => {
      current = false;
    };
  }, []);
  return sites;
}
